// Typelizer digest 4fb9d2f2b4fb0d2239b22870496916cd
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /companies */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/companies', {}, options),
    method: 'get',
  }),

  /** POST /companies */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/companies', {}, options),
    method: 'post',
  }),
}
